export const toAuthApp = () => {
  window.location = `${window.AUTH_WEB_URL}?fromUrl=${window.location.href}`;
};

export const toMainApp = () => {
  window.location.assign(window.BASE_URL);
};
